<template>
  <img
    v-if="user.profile.avatar"
    :src="user.profile.avatar"
    alt="avatar"
    class="avatar-img"
  />
  <div
    v-else
    class="no-avatar"
    :style="
      `background: linear-gradient(to right, ${
        $store.state.campaign.css_settings.primary
      }, ${$store.state.campaign.css_settings.secondary}`
    "
  ></div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Avatar",
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  }
};
</script>

<style lang="scss" scoped>
.avatar-img,
.no-avatar {
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  border-radius: 50%;

  @media (min-width: 767px) {
    position: static;
    transform: translate(0, 0);
  }
}
.no-avatar {
  background: linear-gradient(to right, #6121e6, #ffc4dd);
}
</style>
